import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import styles from './OrganizerResult.module.scss';
import { useIntl } from 'react-intl';

const OrganizerIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={48}
        height={48}
        fill="none"
        {...props}
        className={styles.organizerIcon}
    >
        <path fill="#585163" d="M31 20a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
        <path
            fill="#585163"
            fillRule="evenodd"
            d="m34.345 9.761-3.547-6.684L24 6.4l-6.798-3.323-3.547 6.684-7.453 1.308 1.06 7.492L2 24l5.261 5.439-1.06 7.492 7.454 1.308 3.547 6.684L24 41.6l6.798 3.323 3.547-6.684 7.453-1.308-1.06-7.492L46 24l-5.261-5.439 1.06-7.492-7.454-1.308Zm2.95 4.579-5.567-.977-2.65-4.993L24 10.852 18.921 8.37l-2.649 4.993-5.568.977.792 5.597L7.566 24l3.93 4.063-.792 5.597 1.714.3A15.954 15.954 0 0 1 24 29c4.556 0 8.668 1.904 11.582 4.96l1.714-.3-.792-5.597L40.434 24l-3.93-4.063.792-5.597Z"
            clipRule="evenodd"
        />
    </svg>
);

const eventCountMessageSingle = {
    id: '1 upcoming event',
    defaultMessage: '1 upcoming event',
};

const eventCountMessagePlural = {
    id: '{eventCount} upcoming events',
    defaultMessage: '{eventCount} upcoming events',
};

export const OrganizerResult = ({
    organizerName,
    eventCount,
}: {
    organizerName: string;
    eventCount: number;
}) => {
    const { formatMessage } = useIntl();

    const eventCountMessage = eventCount === 1 ? eventCountMessageSingle : eventCountMessagePlural;

    return (
        <div className={styles.organizerResult}>
            <OrganizerIcon />
            <div className={styles.organizerTextContainer}>
                <Typography variant="body-md-bold" className={styles.organizerText}>
                    {organizerName}
                </Typography>
                <Typography variant="body-caption" className={styles.organizerText}>
                    {formatMessage({ id: 'Organizer', defaultMessage: 'Organizer' })} •{' '}
                    {formatMessage(eventCountMessage, { eventCount })}
                </Typography>
            </div>
        </div>
    );
};
